import api from './api';

export const authService = {
  login: async (email, password) => {
    return api.post('/login', { email, password });
  },

  logout: async () => {
    return api.post('/logout');
  },

  getCurrentUser: async () => {
    return api.get('/user');
  },

  updateProfile: async (data) => {
    return api.put('/profile', data);
  },

  changePassword: async (data) => {
    return api.put('/change-password', data);
  }
};
